import { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

const Signature = ({ onChangeResult, signedName1 = "Yang Bertanda Tangan" }) => {
    const signaturePad1 = useRef(null);
    const containerRef = useRef(null);
    const [canvasWidth, setCanvasWidth] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            if (containerRef.current) {
                setCanvasWidth(containerRef.current.offsetWidth);
            }
        };

        handleResize(); // set initial width
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleDrawEnd = () => {
        if (!signaturePad1.current.isEmpty()) {
            const dataUrl = signaturePad1.current.getTrimmedCanvas().toDataURL("image/png");
            onChangeResult(dataUrl);
        }
    };

    const clearSignature1 = () => {
        signaturePad1.current.clear();
        onChangeResult(null);
    };

    return (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 sm:p-6 mt-6">
            <h3 className="text-lg font-semibold mb-4 text-center">
                {signedName1}
            </h3>

            <div ref={containerRef} className="flex flex-col items-center w-full">
                {canvasWidth > 0 && (
                    <SignatureCanvas
                        ref={signaturePad1}
                        penColor="black"
                        backgroundColor="white"
                        onEnd={handleDrawEnd}
                        canvasProps={{
                            width: canvasWidth,
                            height: (canvasWidth * 0.5), // proporsional 2:1
                            className: "border rounded shadow w-full max-w-md",
                        }}
                    />
                )}

                <button
                    type="button"
                    onClick={clearSignature1}
                    className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded text-sm mt-4"
                >
                    Ulangi Tanda Tangan
                </button>
            </div>
        </div>
    );
};


export default Signature;